import React from "react";
import classnames from "classnames";
import InlineSVG from "react-inlinesvg";

export function Choices({ name, options, selected, onSelect, wrapped = true, multi }) {
  return (
    <>
      <div style={{ visibility: "hidden", height: 0 }}>
        {/* Preload all SVGs to avoid flicker when they are requested initially */}
        <InlineSVG
          src="/assets/radio-selected.svg"
          aria-hidden="true"
        />
        <InlineSVG
          src="/assets/radio-unselected.svg"
          aria-hidden="true"
        />
        <InlineSVG
          src="/assets/check-selected.svg"
          aria-hidden="true"
        />
        <InlineSVG
          src="/assets/check-unselected.svg"
          aria-hidden="true"
        />
      </div>
      <div className={classnames({ "item-list": true, wrapped })}>
        {options.map(({ label, value }) => {
          let isSelected = value === selected;

          const inputProps = {
            type: "radio",
            name,
            value,
            onChange: onSelect,
            id: value,
          };

          if (multi) {
            isSelected = selected.has(value);

            inputProps.type = "checkbox";
            inputProps.checked = isSelected;
          }

          let iconStyle = multi ? "check" : "radio";
          let iconState = isSelected ? "selected" : "unselected";
          let icon = `/assets/${iconStyle}-${iconState}.svg`;

          return (
            <label
              htmlFor={value}
              key={value}
              className={classnames("item", { selected: isSelected })}
            >
              <input {...inputProps} />
              <InlineSVG
                src={icon}
                aria-hidden="true"
              />
              <span>{label}</span>
            </label>
          );
        })}
      </div>
    </>
  );
}
